'use strict';

var _bundle = require('swiper/bundle');

var _bundle2 = _interopRequireDefault(_bundle);

require('swiper/swiper-bundle.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @start Hero image Swiper
// import Swiper
var swiperSection = new _bundle2.default('.full_width_swiper .swiper-container', {
  autoHeight: true,
  spaceBetween: 50,
  keyboard: {
    enabled: true,
    onlyInViewport: false
  },
  observer: true,
  observeSlideChildren: true,
  observeParents: true,
  loop: false,
  // If we need pagination
  pagination: {
    el: '.full_width_swiper .swiper-pagination',
    clickable: true

  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  breakpoints: {
    // when window width is >= 640px
    768: {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      spaceBetween: 0
    }
  }
});

// @start Hero image Swiper

// import Swiper styles
var productSwiper = new _bundle2.default('.product-image-swiper.swiper-container', {

  keyboard: {
    enabled: true,
    onlyInViewport: false
  },

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true

  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },

  spaceBetween: 50
});
// @end Hero image Swiper

// @start Hero image Swiper
// const swiperSectionText = new Swiper('.section_swiper-text .swiper-container', {
//
//   autoHeight: true,
//   effect: 'fade',
//   fadeEffect: {
//     crossFade: true
//   },
//   observer: true,
//   observeSlideChildren: true,
//   observeParents: true,
//
//   keyboard: {
//     enabled: true,
//     onlyInViewport: false,
//   },
//
//   loop: true,
//
//   // If we need pagination
//   pagination: {
//     el: '.swiper-pagination',
//   }
//
// });
// @end Hero image Swiper


// var settings = {
//
//       navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//       },
//       observer: true,
//       observeParents: true,
//       observeSlideChildren: true,
//       speed: 400,
//       allowTouchMove: true,
//       setWrapperSize: true,
//       loop: false,
//       autoHeight: true,
//        effect: 'fade',
//        fadeEffect: {
//          crossFade: true
//        },
//        pagination: {
//          el: '.swiper-pagination',
//        }
//   }
//
//   var costumeSwiper = new Swiper('.section_swiper-text .swiper-container', settings);


// @start Hero image Swiper
var announcement = new _bundle2.default('.announcement-bar .swiper-container-announcement-bar', {

  autoHeight: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },

  keyboard: {
    enabled: true,
    onlyInViewport: false
  },
  autoplay: true,
  loop: true,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  }
});
// @end Hero image Swiper

// @start Hero image Swiper
var imgTxtSwiper = new _bundle2.default('.image-text-slide-container .swiper-container', {

  autoHeight: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },

  keyboard: {
    enabled: true,
    onlyInViewport: false
  },

  loop: true,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }

});
// @end Hero image Swiper


// @start Hero image Swiper
var prodMethods = new _bundle2.default('.product_method .swiper-container', {

  autoHeight: true,
  // loop: true,
  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  spaceBetween: 20,

  observer: true,
  observeSlideChildren: true,
  observeParents: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  breakpoints: {
    // when window width is >= 640px
    768: {

      spaceBetween: 40
    }
  }
});
// @end Hero image Swiper